import React, { useState, useEffect } from 'react'
import { api } from 'src/services/api';
import MatchQueueBamLink from './match-queue-bam-link';
import { Loader } from '../../misc/loader-utils';

import './styles/match-queue.scss'

function MatchQueue( { match }) {

  const { queueSlug } = match.params;

  const [bamLinks, setBamLinks] = useState([])
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    callApiAndSetLinks()
  }, [])

  async function callApiAndSetLinks() {
    const endPoint = `/api/v2/product_match/match_queues/${queueSlug}/bam_links/`;
    const resp = await api.get(endPoint)
    setBamLinks(resp.data.data)
    setLoading(false)
  }

  return (
    <div className="match-queue-container">
      <div className="title-area">
        <h1>{ queueSlug } </h1>
      </div>
      <div className="links-table">
        <div className="queue-headers">
          <span className="bam-link-id">BamLink Id</span>
          <span className="datetime-created">Created (Local)</span>
          <span className="lock-status">Lock Status</span>
          <span className="match-page-button">Match Page Link</span>
        </div>
        <div className="links-list">
          <Loader loading={loading} />
        {bamLinks.map(link => <MatchQueueBamLink bamLink={link} queueSlug={queueSlug} key={link.bam_link_id}/>)}
        </div>
      </div>
    </div>
  )
}

export default MatchQueue
